import axios, { LONG_TIMEOUT_MS } from "utils/axios";
import queryString from "query-string";

export const createContactTag = ({ id, ...payload }) => {
  return axios.post(`/WA/contacts/${id}/tags`, payload);
};

export const getContactTags = (id) => {
  return axios.get(`/WA/contacts/${id}/tags`);
};

export const deleteContactTag = ({ contactId, tagId }) => {
  return axios.delete(`/WA/contacts/${contactId}/tags/${tagId}`);
};

//Contact Group
export const getSummaryContact = () => {
  return axios.get(`/WA/contacts/summary`);
};
export const getContactGroup = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/WA/contactGroups?${query}`);
};
export const createContactGroup = (payload) => {
  return axios.post(`/WA/contactGroups`, payload);
};
export const updateContactGroup = ({ payload, id }) => {
  return axios.put(`/WA/contactGroups/${id}`, payload);
};
export const getContactCanBeDeleted = () => {
  return axios.get(`/WA/contactGroups/canBeDeleted`);
};
export const deleteContactGroup = (id) => {
  return axios.delete(`/WA/contactGroups/${id}`);
};
export const moveContactGroup = (payload) => {
  return axios.patch(`/WA/contactGroups/${payload.id}/move`, {
    dest_id: payload.dest_id,
  });
};

//contact
export const getContact = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/WA/contacts?${query}`);
};

export const getContactDetail = (id) => {
  return axios.get(`/WA/contacts/${id}`);
};

export const createContact = (payload) => {
  return axios.post(`/WA/contacts`, payload);
};

export const checkContactMassDelete = (payload) => {
  return axios.post("/WA/contacts/inputMassDelete", payload);
};

export const deleteContactMassDelete = (payload) => {
  return axios.delete("/WA/contacts/executeMassDelete", { data: payload });
};

export const getSuggestionContact = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/WA/contacts/suggestionPerPage?${query}`);
};

export const deleteTemporaryPhoto = (url) => {
  return axios.delete("/WA/contacts/photo", { data: { url } });
};
export const deletePhotoById = (url, id) => {
  return axios.delete(`/WA/contacts/${id}/photo`, { data: { url } });
};

// contact reports
export const getContactReportsGraph = (params) => {
  const query = queryString.stringify(params);
  return axios.get(`/WA/reportings/graphs?${query}`);
};

//contact detail
export const getContactStats = (id) => {
  return axios.get(`/WA/contacts/${id}/stats`);
};
export const getContactTemplateMessages = (id) => {
  return axios.get(`/WA/contacts/${id}/templateMessages`);
};
export const deleteContactById = (id) => {
  return axios.delete(`/WA/contacts/${id}`);
};
export const archiveContact = (id) => {
  return axios.patch(`/WA/contacts/${id}/archive`);
};
export const unarchiveContact = (id) => {
  return axios.patch(`/WA/contacts/${id}/unarchive`);
};
export const updateContact = (payload) => {
  return axios.patch(`/WA/contacts/${payload.id}`, payload);
};

//block contact

export const blockContact = ({ id, is_block }) => {
  return axios.post(`/WA/contacts/${id}/block`, {
    is_block,
  });
};

export const exportContact = (name, params, type) => {
  return axios.get(`/WA/contacts`, {
    params: { ...params, export: type },
    responseType: "blob",
    timeout: LONG_TIMEOUT_MS,
  });
};

//import contact
export const uploadImportContact = (formData) => {
  return axios.post(`/WA/contacts/uploadImport`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: LONG_TIMEOUT_MS,
  });
};

export const executeImportContact = (payload) => {
  return axios.post(`/WA/contacts/executeImport`, payload);
};

export const downloadImportContactTemplate = () => {
  return axios.get(`/WA/download/import/crm-contact-template.xlsx`, {
    responseType: "blob",
    timeout: LONG_TIMEOUT_MS,
  });
};

export const downloadImportContactExample = () => {
  return axios.get(`/WA/download/import/crm-contact-example.xlsx`, {
    responseType: "blob",
    timeout: LONG_TIMEOUT_MS,
  });
};
